<template>
    <div class="content">
        <label>{{ countHeader }} </label>
        <slider
            :slider-id="'1'"
            :slider-header="sliderHeader"
            :slider-min-value-label="timelineMin"
            :slider-max-value-label="timelineMax"
            :slider-current-date="timelineCurrentDate"
            :step-value="1"
            @update-map="sliderChange"
        />
        <br>
        <!-- TODO: tarvitseeko häiriöajanhetkenä palleroa näyttää jos listalla näytetään vain valitun ajan hetken häiriöt?
        Jos listalla on koko valittu aikajana niin silloin pallero on hyödyllinen mutta silloin luettelo pitäisi scrollata aina oikeaan kohtaan... -->
        <dynamic-table
            :table-heading="tableHeader"
            :table-data="tableData"
            :show-footer="true"
            :footer-header="'App.ViatJaHairiot.Selitys'"
            :footer-text="'App.ViatJaHairiot.HairioValittunaAjanhetkena'"
            :show-footer-legend="true"
            @row-clicked="tableRowClicked"
        />
    </div>
</template>

<script lang="ts">
    import { Component, Vue, Watch } from "vue-facing-decorator"
    import moment from "moment"
    import DateSlider from "@/components/DateSlider.vue"
    import DynamicRightSlotData from "@/models/dynamicrighslotdata"
    import DynamicTableResponsive from "@/components/DynamicTableResponsive.vue"
    import TableData from "@/models/tabledata"
    import { store } from '@/store/store'

    @Component({
        components: {
            slider: DateSlider,
            "dynamic-table": DynamicTableResponsive
        }
    })
    export default class ViatJaHairiotTiedot extends Vue {
        // alustetaan aikarajaus, kuluva 12kk oletuksena
        get timelineCurrentDate(): string {
            return moment().format("MM-DD-YYYY")
        }

        get timelineMax(): string {
            return moment().format("MM-DD-YYYY")
        }

        get timelineMin(): string {
            return moment().subtract(1, "year").format("MM-DD-YYYY")
        }

        selectedArea = ""
        tablecount = 0
        @Watch("slotData")
        onFilterValueChange(): void {
            this.updateFilters()
            this.refreshTable()
        }

        async activated() {
            this.onFilterValueChange()
        }

        /** päivitetään tablen datat */
        refreshTable(): void {
            this.tablecount = this.tableData.extendedData?.size ?? 0
            const tabledata = (store.getters.tableData as TableData) ?? TableData.empty()
            tabledata.extendedData?.forEach((value: boolean, key: string[]) => {
                const startDate = moment(key[0], "DD.MM.YYYY").startOf("day")
                const endDate = moment(key[1], "DD.MM.YYYY").endOf("day")
                const curDate = moment(this.timelineCurrentDate, "MM-DD-YYYY").add(12, "hours")
                if (curDate.isBetween(startDate, endDate, "hour")) {
                    value = true
                }
                else {
                    value = false
                }
            })
            // console.log(tabledata)
            store.dispatch("setTableData", tabledata)
        }

        get tableData(): TableData {
            const tabledata = (store.getters.tableData as TableData) ?? TableData.empty()
            this.tablecount = tabledata.extendedData?.size ?? 0
            tabledata.extendedData?.forEach((value: boolean, key: string[]) => {
                const startDate = moment(key[0], "DD.MM.YYYY").startOf("day")
                const endDate = moment(key[1], "DD.MM.YYYY").endOf("day")
                const curDate = moment(this.timelineCurrentDate, "MM-DD-YYYY").add(12, "hours")
                if (curDate.isBetween(startDate, endDate, "hour")) {
                    value = true
                }
                else {
                    value = false
                }
            })
            return tabledata
        }

        // TODO- mitä vaihtoehtoja voi aikajanaksi tulla?
        updateFilters(): void {
            const timeline = this.slotData?.filters?.get("Timeline")
            switch (timeline) {
                case "Viimeisin12kk":
                    this.timelineCurrentDate = moment().format("MM-DD-YYYY")
                    this.timelineMax = moment().format("MM-DD-YYYY")
                    this.timelineMin = moment().subtract(1, "year").format("MM-DD-YYYY")
                    break
                default:
                    this.timelineCurrentDate = moment(timeline).endOf("year").format("MM-DD-YYYY")
                    this.timelineMax = moment(timeline).endOf("year").format("MM-DD-YYYY")
                    this.timelineMin = moment(timeline).startOf("year").format("MM-DD-YYYY")
                    break
            }
        }

        tableRowClicked() {
            // avataan modaali tarkempien tietojen näyttämiseksi
            this.openModal()
        }

        openModal() {
            // TODO: modaalin sisältö
            store.dispatch("setModalComponentName", "ViatJaHairiotModal")
        }

        async sliderChange(item: string) {
            // TODO kartan ja listan päivitys?
            // nyt lisätään listaan vain pallero jos sliderin pvm osuu siihen...
            // miten kartan suodatus????
            this.timelineCurrentDate = item
            this.refreshTable()
        }

        get sliderHeader(): string | undefined {
            return this.$t("App.ViatJaHairiot.SliderHeader")
        }

        get tableHeader(): string | undefined {
            return this.$t("App.ViatJaHairiot.VikaJaHairiotTilanteet")
        }

        get countHeader(): string | undefined {
            return this.$t("App.ViatJaHairiot.Maara") + ": " + this.tablecount + " " + this.$t("App.ViatJaHairiot.Kpl")
        }

        get slotData(): DynamicRightSlotData | null {
            return (store.getters.rightSlotData as DynamicRightSlotData)
        }
    }
</script>
